/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Layout-include admin list, editor, and copy modal.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {CodemirrorModule} from '../../common/directives/codemirror.module';
import {FormControlsModule} from '../../common/directives/form-controls/form-controls.module';
import {LayoutIncludeEditPageComponent} from './layout-include-edit-page.component';
import {LayoutIncludeListPageComponent} from './layout-include-list-page.component';
import {LayoutIncludeCopyModalComponent} from './layout-include-copy-modal.component';
import {LayoutIncludeRoutePageComponent} from './layout-include-route-page.component';

const LAYOUT_INCLUDE = [
  LayoutIncludeEditPageComponent,
  LayoutIncludeListPageComponent,
  LayoutIncludeCopyModalComponent,
  LayoutIncludeRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    AdminListModule,
    CodemirrorModule,
    FormControlsModule
  ],
  declarations: LAYOUT_INCLUDE,
  exports: LAYOUT_INCLUDE
})
export class LayoutIncludeModule {
}
